<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div v-if="!loading">
      <template v-if="!multiSearch">
        <section
          v-if="items && items.length === 0"
          class="section is-main-section has-text-centered"
        >
          <!-- <h1 class="title">Not Found</h1> -->
          <h1 class="title">No items found.</h1>
        </section>
        <section
          v-if="items && items.length > 0"
          class="section has-text-centered"
        >
          <h1 class="title">
            {{ items[0].metadata_type | capitalize }} - {{ items[0].value }}
          </h1>
          <p v-if="empty">No items found.</p>
        </section>
      </template>
      <template v-if="multiSearch">
        <section
          v-if="categories && categories.length === 0"
          class="section is-main-section has-text-centered"
        >
          <h1 class="title">Not Found</h1>
        </section>
        <section class="section has-text-centered">
          <h1 class="title">
            {{ category1 | capitalize }} -
            {{ category2 | capitalize }}
          </h1>
          <p v-if="items.length === 0">No items found.</p>
        </section>
      </template>
      <section
        v-if="(!empty && !categories) || (multiSearch && items.length > 0)"
        class="section is-main-section has-margin-left-30"
      >
        <div class="columns is-multiline is-centered">
          <div
            v-for="item in items"
            :key="item.id"
            class="column is-2-desktop has-text-centered"
          >
            <img
              v-if="item.mediadata"
              :src="thumbnail(item.mediadata.titleImage)"
              :alt="item.title"
              @click.prevent="showDetail(item)"
            />
          </div>
        </div>
      </section>
      <section
        v-if="!empty && categories && !multiSearch"
        class="section is-main-section has-margin-left-30"
      >
        <div v-for="category in categories" :key="category">
          <h2 class="is-size-3 has-margin-top-15">{{ category }}</h2>
          <CategorySlider
            :items="getTitlesByCategory(category)"
          ></CategorySlider>
        </div>
        <div v-if="otherTitles.length > 0">
          <h2 class="is-size-3 has-margin-top-15">Other</h2>
          <CategorySlider :items="otherTitles"></CategorySlider>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaApi from '@/api/media'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import CategorySlider from '@/components/CategorySlider'
import MediaDetailModal from '@/components/MediaDetailModal'
import AuthRequiredModal from '@/components/AuthRequiredModal'

export default {
  name: 'Metadata',
  components: {
    CategorySlider
  },
  mixins: [Filters, Utils],
  metaInfo() {
    let title = ''
    if (!this.loading && this.items.length > 0) {
      if (this.multiSearch) {
        title = `${this.capitalizeText(this.category1)} -
          ${this.capitalizeText(this.category2)}`
      } else {
        title = `${this.capitalizeText(this.items[0].metadata_type)} - ${
          this.items[0].value
        }`
      }
    }

    return {
      title: title
    }
  },
  data() {
    return {
      loading: true,
      items: [],
      empty: false,
      categories: null,
      category1: null,
      category2: null
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    multiSearch() {
      return this.$route.name !== 'Metadata'
    },
    otherTitles() {
      if (this.items && this.items.length > 0) {
        return this.items.filter(
          item => item.childCategories && item.childCategories.length === 0
        )
      }
      return []
    }
  },
  watch: {
    $route() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    getTitlesByCategory(category) {
      return this.items.filter(item => item.childCategories.includes(category))
    },
    showDetail(item) {
      if (this.isAuthenticated) {
        this.$buefy.modal.open({
          parent: this,
          component: MediaDetailModal,
          hasModalCard: true,
          props: {
            id: item.media_id ? item.media_id : item.id
          },
          trapFocus: true
        })
      } else {
        this.$buefy.modal.open({
          parent: this,
          component: AuthRequiredModal,
          hasModalCard: true,
          trapFocus: true
        })
      }
    },
    fetchData() {
      this.loading = true
      if (!this.multiSearch) {
        MediaApi.byMetadataId(this.$route.params.id).then(response => {
          if (response && response.media && response.media.length > 0) {
            response.media.forEach(
              item => (item.mediadata = JSON.parse(item.mediadata))
            )
            this.items = response.media
            this.categories = response.categories
            if (!this.items[0].id) {
              this.empty = true
            } else {
              this.empty = false
            }
          } else {
            this.items = []
            this.categories = []
          }
          this.loading = false
        })
      } else {
        MediaApi.byMetadataIds([
          this.$route.params.id1,
          this.$route.params.id2
        ]).then(response => {
          if (response.categories) {
            this.categories = response.categories
            const searchCategory1 = this.categories.find(
              item => item.id === parseInt(this.$route.params.id1, 10)
            )
            const searchCategory2 = this.categories.find(
              item => item.id === parseInt(this.$route.params.id2, 10)
            )
            if (searchCategory1) {
              this.category1 = searchCategory1.value
            }
            if (searchCategory2) {
              this.category2 = searchCategory2.value
            }
          }

          if (response && response.media && response.media.length > 0) {
            response.media.forEach(
              item => (item.mediadata = JSON.parse(item.mediadata))
            )
            this.items = response.media

            if (!this.items[0].id) {
              this.empty = true
            } else {
              this.empty = false
            }
          } else {
            this.items = []
          }
          this.loading = false
        })
      }
    }
  }
}
</script>
